export const DEFAULT_MODEL_RATE = Object.freeze({ inputPerMillion: 0, outputPerMillion: 0 });
export const MODEL_OPTION_SEPARATOR = '::';
export const DEFAULT_COST_MODEL_NAME = 'MiniMax-M3';
export const SUPPORTED_COST_MODELS = Object.freeze([
  { name: 'MiniMax-M2.7-highspeed', provider: 'minimax', label: 'MiniMax 2.7 highspeed' },
  { name: 'MiniMax-M3', provider: 'minimax', label: 'MiniMax M3' },
]);

export function getModelOptionValue(item = {}) {
  const provider = String(item.provider || '').trim().toLowerCase() || 'minimax';
  const name = String(item.name || '').trim();
  return `${encodeURIComponent(provider)}${MODEL_OPTION_SEPARATOR}${encodeURIComponent(name)}`;
}

export function parseModelOptionValue(value) {
  const raw = String(value || '');
  const separatorIndex = raw.indexOf(MODEL_OPTION_SEPARATOR);
  if (separatorIndex === -1) return { provider: 'minimax', name: raw };
  return {
    provider: decodeURIComponent(raw.slice(0, separatorIndex) || 'minimax'),
    name: decodeURIComponent(raw.slice(separatorIndex + MODEL_OPTION_SEPARATOR.length) || ''),
  };
}

export function getDefaultModelCandidate(modelCandidates = []) {
  return modelCandidates.find((item) => item.name === DEFAULT_COST_MODEL_NAME)
    || modelCandidates[0]
    || { name: DEFAULT_COST_MODEL_NAME, provider: 'minimax', label: 'MiniMax M3' };
}

export function normalizeModelRateEntry(entry = {}) {
  const inputPerMillion = Number(entry.inputPerMillion ?? entry.inputPricePerMillion ?? entry.inputPerMillionCny ?? 0);
  const outputPerMillion = Number(entry.outputPerMillion ?? entry.outputPricePerMillion ?? entry.outputPerMillionCny ?? 0);
  if (inputPerMillion > 0 || outputPerMillion > 0) {
    return {
      inputPerMillion: Number.isFinite(inputPerMillion) ? inputPerMillion : 0,
      outputPerMillion: Number.isFinite(outputPerMillion) ? outputPerMillion : 0,
    };
  }
  const fee = Number(entry.fee || 0);
  const totalUnits = Number(entry.totalUnits || 0);
  const legacyPerMillion = totalUnits > 0 ? (fee / totalUnits) * 1_000_000 : 0;
  return {
    inputPerMillion: Number.isFinite(legacyPerMillion) ? legacyPerMillion : 0,
    outputPerMillion: Number.isFinite(legacyPerMillion) ? legacyPerMillion : 0,
  };
}

export function calculateModelCost(inputTokens, outputTokens, config = DEFAULT_MODEL_RATE) {
  return (Number(inputTokens || 0) / 1_000_000) * Number(config.inputPerMillion || 0)
    + (Number(outputTokens || 0) / 1_000_000) * Number(config.outputPerMillion || 0);
}

export function guessModelProvider(modelName, modelCandidates = []) {
  const found = modelCandidates.find((item) => item.name === modelName);
  return found?.provider || 'minimax';
}

export function marketLabel(provider) {
  if (provider === 'sorftime') return '数派（sorftime）';
  if (String(provider || '').includes('seller')) return '卖家精灵（sellersprite）';
  return provider;
}

export function getUsageMarketCalls(usage = {}) {
  return Number(usage.totalSellerspriteCalls || 0);
}

export function getUserMarketCalls(user = {}) {
  return Number(user.sellerspriteCalls || user.sorftimeCalls || 0);
}
